import { useState, useEffect } from 'react';
import { Spinner, Inline } from '@airbus/components-react';
import styles from './Spinner.module.css';
import i18next from '../../i18next';

export default function Spinners() {
  const [ready, setReady] = useState(false);

  const [pleaseWaitTranslationValue, setPleaseWaitTranslationValue] = useState('');

  useEffect(() => {
    const handleReady = () => {
      const hasTranslation = i18next.getResource(i18next.language, 'translation', 'please_wait');     

      if (hasTranslation) {
        setReady(true);
        setPleaseWaitTranslationValue(hasTranslation);
      }
    };

    if (i18next.isInitialized) {
      handleReady();
    } else {
      i18next.on('initialized', handleReady);
    }

    i18next.on('loaded', handleReady);

    return () => {
      i18next.off('initialized', handleReady);
      i18next.off('loaded', handleReady);
    };
  }, []);

  if (!ready) return null;

  return (
    <Inline className={styles.flexSpinner}>
      <Spinner size='medium' label={pleaseWaitTranslationValue} />
    </Inline>
  );
}
